import React from "react";
import CommonDialog from "./utils/Dialogs";
import CustomSnackbar from "./utils/Snakbar";
import {
  Button,
  FormControl,
  TextField,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  RadioGroup,
  Radio,
  Divider,
} from "@mui/material";

export default function AddDimension(props) {
  const {
    open,
    optionalDimension,
    dimension,
    multipleChoice,
    maxChoices,
    paidSupplement,
    amountSupplement,
    type: code,
    submitting,
    openSnack,
    snackbarMessage,
    editingDimension,
    copyMode,
    selectedItemId,
    selectedDimensionType,
    filteredAndSortedItems,
    availableDimensions,
    searchTerm,
    onOptionalDimensionChange,
    onDimensionChange,
    onMultipleChoiceChange,
    onMaxChoicesChange,
    onPaidSupplementChange,
    onAmountSupplementChange,
    onTypeChange,
    openDialog,
    closeDialog,
    onSave,
    onCancel,
    onCloseSnack,
    onCopyModeChange,
    onItemSelect,
    onDimensionSelect,
    onSearchChange,
  } = props;

  const isEditMode = !!editingDimension;

  return (
    <>
      <CustomSnackbar
        text={snackbarMessage}
        open={openSnack}
        onCloseSnakbar={onCloseSnack}
      />

      <Button variant="contained" onClick={openDialog}>
        Ajouter une caractéristique
      </Button>

      <CommonDialog
        onClose={closeDialog}
        open={open}
        title={isEditMode ? "Modifier la dimension" : "Ajouter une dimension"}
        render={() => (
          <>
            <Typography
              variant="subtitle1"
              sx={{
                mt: 2,
                mb: 3,
                display: "inline-block",
              }}
            >
              Une dimension peut-être une taille, une couleur, etc.
            </Typography>

            <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
              {/* Mode de création : Nouveau ou Copie */}
              {!isEditMode && (
                <>
                  <FormControl component="fieldset" sx={{ mb: 3 }}>
                    <RadioGroup
                      row
                      value={copyMode ? "copy" : "new"}
                      onChange={(e) =>
                        onCopyModeChange({
                          target: { checked: e.target.value === "copy" },
                        })
                      }
                    >
                      <FormControlLabel
                        value="new"
                        control={<Radio />}
                        label="Créer une nouvelle dimension"
                      />
                      <FormControlLabel
                        value="copy"
                        control={<Radio />}
                        label="Copier depuis un autre article"
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Section de copie */}
                  {copyMode && (
                    <Box
                      sx={{ mb: 3, p: 2, bgcolor: "grey.50", borderRadius: 1 }}
                    >
                      {/* Champ de recherche */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <TextField
                          label="Rechercher un article"
                          variant="outlined"
                          value={searchTerm}
                          onChange={onSearchChange}
                          placeholder="Tapez pour filtrer les articles..."
                          size="small"
                        />
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Sélectionner un article</InputLabel>
                        <Select
                          value={selectedItemId}
                          onChange={onItemSelect}
                          label="Sélectionner un article"
                        >
                          <MenuItem value="">
                            <em>-- Choisir un article --</em>
                          </MenuItem>
                          {filteredAndSortedItems.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {selectedItemId && (
                        <FormControl fullWidth>
                          <InputLabel>Sélectionner une dimension</InputLabel>
                          <Select
                            value={selectedDimensionType}
                            onChange={onDimensionSelect}
                            label="Sélectionner une dimension"
                            disabled={!availableDimensions.length}
                          >
                            <MenuItem value="">
                              <em>-- Choisir une dimension --</em>
                            </MenuItem>
                            {availableDimensions.map((dim) => (
                              <MenuItem key={dim.type} value={dim.type}>
                                {dim.title} ({dim.type})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  )}

                  <Divider sx={{ my: 2 }} />
                </>
              )}

              {/* checkbox for optional dimension */}
              <FormControlLabel
                control={<Checkbox />}
                label="Obligatoire"
                checked={!optionalDimension}
                onChange={onOptionalDimensionChange}
              />

              <FormControl fullWidth>
                <TextField
                  label="Dimension"
                  variant="outlined"
                  value={dimension}
                  fullWidth
                  onChange={onDimensionChange}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  label="Code"
                  variant="outlined"
                  margin="normal"
                  value={code}
                  fullWidth
                  onChange={onTypeChange}
                  disabled={isEditMode}
                />
              </FormControl>

              {/* checkbox and input field should be in the same line */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}
              >
                {/* boolean choice for multiple choices or not */}
                <FormControlLabel
                  control={<Checkbox />}
                  label="Autoriser les choix multiples"
                  checked={multipleChoice}
                  onChange={onMultipleChoiceChange}
                />

                {/* add a input number to set max choices */}
                <TextField
                  label="Nombre maximum de choix"
                  variant="outlined"
                  type="number"
                  value={maxChoices}
                  onChange={onMaxChoicesChange}
                  disabled={!multipleChoice}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mt: 2,
                }}
              >
                {/* Ajouter une checkbox pour supplement payant ainsi qu'un input number pour le prix */}
                <FormControlLabel
                  control={<Checkbox />}
                  label="Coût du supplément"
                  checked={paidSupplement}
                  onChange={onPaidSupplementChange}
                />

                <TextField
                  label="Prix"
                  variant="outlined"
                  type="number"
                  value={amountSupplement}
                  onChange={onAmountSupplementChange}
                  disabled={!paidSupplement}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  mt: 5,
                  py: 1,
                }}
              >
                <Button
                  variant="contained"
                  onClick={onSave}
                  disabled={submitting}
                >
                  Sauver
                </Button>
                <Button
                  variant="contained"
                  disabled={submitting}
                  onClick={onCancel}
                >
                  Annuler
                </Button>
              </Box>
            </Box>
          </>
        )}
      />
    </>
  );
}
